<template>
  <div class="wrapper">
    <div v-if="layoutLinear === false">  
      <label >{{label}}</label>
      <b-input-group>
         <autocomplete 
                :source="uri"
                :placeholder="place"
                :input-class-required="!classeRequired"
                results-display="CODIGONOME"
                results-value="ID"
                :disableInput="desabilitarInput"
                @input="setId"
                @clear="clearComplete({})"
                ref="auto">
          </autocomplete>
          <b-input-group-append v-if="!desabilitarInput">
            <b-btn variant="outline-secondary" :disabled="desabilitarInput" v-b-modal="idModal">{{labelBotao}}
              <i class="fa fa-search"></i></b-btn>
          </b-input-group-append>
      </b-input-group>
    </div>
    <b-row v-if="layoutLinear === true" md="12" class="mb-1">
        <b-col  :md="tamanhoColunaLabel">
            <label>{{label}}</label>
        </b-col>
        <b-col  :md="tamanhoColunaAutocomplete">
            <b-input-group>
                <autocomplete 
                    :source="uri"
                    :placeholder="place"
                    :input-class-required="!classeRequired"
                    results-display="CODIGONOME"
                    results-value="ID"
                    :disableInput="desabilitarInput"
                    @input="setId"
                    @clear="clearComplete({})"
                    ref="auto">
                </autocomplete>
                <b-input-group-append v-if="!desabilitarInput">
                    <b-btn variant="outline-secondary" :disabled="desabilitarInput" v-b-modal="idModal">{{labelBotao}}
                        <i class="fa fa-search"></i>
                    </b-btn>
                </b-input-group-append>
            </b-input-group>
        </b-col>
    </b-row>
    <b-modal :id="idModal"
             :ref="idModal"
             title="Pesquisar Ordem de Abate Fechada"
             class="modal-primary"
             size="xl"
             ok-title="Cancelar"
             ok-only
             centered
             @shown="clearModal">
      <b-card>
      <form @submit.stop.prevent="handleSubmit">
        <!-- <b-form-input type="text" placeholder="Enter your name" v-model="resultado"></b-form-input> -->
        <b-row>
          <!--/.col-->
          <b-col sm="8">
                <b-form-input type="text" id="nome" ref="edNomePesquisa" placeholder="Informe o Nome" v-model="pesquisa.nome"> </b-form-input>
          </b-col>
          <b-col sm="4">
            <!-- Button -->
            <b-button  type="submit" variant="primary" @click.stop.prevent="onSubmit()">
              <span>Pesquisar</span>
            </b-button> 
            <!-- Button -->
            <b-button type="reset"  variant="danger">
                  <i class="fa fa-ban"></i> Limpar
            </b-button>
          </b-col>
        </b-row>
      </form>
      </b-card>
      <b-row >
        <b-col sm="12">
            <!-- Main table element -->
            <b-table  class="table table-sm"
                    show-empty
                    empty-text="Informe o filtro para ver os pesquisas "
                    stacked="md"
                    small
                    responsive 
                    striped 
                    hover 
                    :busy.sync="isBusy" 
                    :items="items" 
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="filter"
                    @row-clicked="selecionar">
              <template #cell(ID)="item">{{item.item.ID}}</template>
              <template #cell(NOME_FORNECEDOR)="item">{{item.item.NOME_FORNECEDOR}}</template>
              <template #cell(STATUS)="item">
                <b-badge pill :variant="colorirStatus(item.item.OP_STATUS)">{{traduzirStatus(item.item.OP_STATUS)}}</b-badge>
              </template>      
              <template #cell(TIPO_SERVICO_TRADUZIDO)="item">
                <b-badge pill :variant="colorirTipoServico(item.item.OP_TIPO_SERVICO)">{{item.item.TIPO_SERVICO_TRADUZIDO}}</b-badge>
              </template>   
            </b-table>
            <div  class="justify-content-center row my-1">
              <b-pagination size="md" :total-rows="this.items.length" :per-page="perPage" v-model="currentPage" />
            </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import VueButtonSpinner from '../../components/VueButtonSpinner.vue'
import Autocomplete from '../componentes/Autocomplete'
import moment from 'moment'

export default {
  props: {
    label: String,
    place: String,
    labelBotao: String,
    idInicial: Number,
    classeRequired: Boolean,
    idModal: String,
    desabilitarInput: Boolean,
    layoutLinear: Boolean,
    tamanhoColunaLabel: String,
    tamanhoColunaAutocomplete: String
  },
  data () {
    return {
      resultado: '',
      pesquisa: {
        id: '',
        nome: ''
      },
      isLoading: false,
      isBusy: false,
      status: '',
      items: [],
      fields: [
        {
          key: "ID",
          label: 'Id',
          sortable: true,
          class:'text-right font-weight-bold my-left-border my-left-right my-left-bottom',
        },
        {
          key: "LOTE",
          label: 'Lote',
          class:'text-right font-weight-bold my-left-border my-left-right my-left-bottom',
          sortable: true 
        },
        {
          key: "NOME_FORNECEDOR",
          label: 'Fornecedor', 
          thStyle: { width: "15%" },
          class: 'my-left-border my-left-right my-left-bottom', 
          sortable: true 
        },
        {
          key: "STATUS",
          label: 'Status', 
          sortable: true,
          class: 'my-left-border my-left-right my-left-bottom', 
          thStyle: { width: "5%" }, 
        },
        {
          key: "TIPO_SERVICO_TRADUZIDO",
          label: 'Processo',
          class: 'my-left-border my-left-right my-left-bottom', 
          thStyle: { width: "7%" },
          sortable: true 
        },
        {
          key: "DT_LOTE",
          label: 'Data', 
          sortable: true,
          
          class:'text-right my-left-border my-left-right my-left-bottom',
          formatter: (value, key, item) => 
            moment(String(value)).format('DD/MM/YYYY')
        },
        {
          key: "BOI_PECAS",
          label: 'Boi', 
          class:'text-right my-left-border my-left-right my-left-bottom',
          thStyle: { width: "5%" },
          sortable: true 
        },
        {
          key: "VACA_PECAS",
          label: 'Vaca', 
          class:'text-right my-left-border my-left-right my-left-bottom',
          thStyle: { width: "5%" },
          sortable: true 
        },
        {
          key: "BOI_CAPAO_PECAS",
          label: 'Capão', 
          class:'text-right my-left-border my-left-right my-left-bottom',
          thStyle: { width: "5%" },
          sortable: true 
        },
        {
          key: "NOVILHA_PECAS",
          label: 'Novilha', 
          class:'text-right my-left-border my-left-right my-left-bottom',
          thStyle: { width: "5%" },
          sortable: true 
        },
        {
          key: "TOURO_PECAS",
          label: 'Touro', 
          class:'text-right my-left-border my-left-right my-left-bottom',
          thStyle: { width: "5%" },
          sortable: true 
        },
        {
          key: "BUFALO_MACHO_PECAS",
          label: 'Buf M', 
          class:'text-right my-left-border my-left-right my-left-bottom',
          thStyle: { width: "5%" },
          sortable: true 
        },
        {
          key: "BUFALO_FEMEA",
          label: 'Buf. F', 
          class:'text-right my-left-border my-left-right my-left-bottom',
          thStyle: { width: "5%" },
          sortable: true 
        },
        {
          key: "ANIMAIS",
          label: 'Cabeças', 
          class:'text-right my-left-border my-left-right my-left-bottom',
          thStyle: { width: "7%" },
          sortable: true 
        },
        {
          key: 'QUANT', 
          class:'text-right', 
          label: 'Peso KG', 
          class:'text-right font-weight-bold my-left-border my-left-right my-left-bottom',
          sortable: true,
          formatter: (value, key, item) => 
            value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : null
        }
      ],
      currentPage: 1,
      perPage: 5,
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalDetails: { index: '', data: '' },
      uri: this.$http.defaults.baseURL.concat('api/protected/abate/autocompleteEncerradas?&texto='),
      classeBorda: 'teste'
    }
  },
  components: {
    VueButtonSpinner,
    Autocomplete
  },
  methods: {
    setId (evt) {
      this.$emit('retornaId', evt)
    },
    clearComplete (obj) {
      this.$emit('retornaId', null)
    },
    clearModal () {
      this.items = []
      this.pesquisa.id = ''
      this.pesquisa.nome = ''
      this.$refs.edNomePesquisa.focus()
      //this.$refs.auto.$refs.autocomplete.focus()
    },
    selecionar (evt) {
      this.$emit('retornaId', evt.ID)
      this.$emit('retornaNome', evt.CODIGONOME)
      this.clearModal()
      this.$refs[this.idModal].hide()
      // Mudar o display do autocomplete..
      this.$refs.auto.display = evt.CODIGONOME
    },
    onSubmit () {
      if ((!this.pesquisa.id) && (!this.pesquisa.nome)) {
        alert('Por Favor! Informe algum texto/valor para pesquisar')
        return
      }
      this.isLoading = true
      this.isBusy = true
      let uri = `/api/protected/producao/listarordensencerradas/?idPesquisa=${this.pesquisa.id}&nomePesquisa=${this.pesquisa.nome}`
      let promise = this.$http.get(uri)
      return promise.then((data) => {
        this.items = data.data
        this.isBusy = false
        this.isLoading = false
        this.status = true // or success
        setTimeout(() => {
          this.status = ''
        }, 1000) // to clear the status :)
      }).catch((error) => {
        if (error) {
          this.items = []
          this.isLoading = false
          this.status = false // or error
        }
      })
    },
    colorirTipoServico(valor) {
      if (valor == '0') return 'success' //Proprio
      else if (valor == '1') return 'orange' // Servico
      else return 'success'
    },
    colorirStatus(valor) {
      if (valor == '0') return 'danger' // cancelada
      else if (valor == '1') return 'yellow' //lancamentos principais
      else if (valor == '2') return 'teal' // Planejamento Iniciado
      else if (valor == '3') return 'blue' // Pronto para coleta
      else if (valor == '4') return 'purple' // Colente Iniciada
      else if (valor == '5') return 'orange' // coleta encerrada
      else if (valor == '6') return 'green' // fechado
      else return 'gray-dark'
    },
    traduzirStatus(item) {
      if (item == null) return ''
      
      switch (item) {
        case  '0' : return 'CANCELADA'
        case  '1' : return 'LANCAMENTO PRINCIPAIS' 
        case  '2' : return 'PLANEJAMENTO INICIADO' 
        case  '3' : return 'PRONTO PARA COLETA' 
        case  '4' : return 'COLETA INICIADA' 
        case  '5' : return 'COLETA ENCERRADA'     
        case  '6' : return 'FECHADO' 
        default: 
          break;
      }
    },
    atualizaComplete () {
      if (this.idInicial) {
        let uri = `/api/protected/abate/pesquisarIdMinEncerradas?idPesquisa=${this.idInicial}`
        let promise = this.$http.get(uri)
        return promise.then((data) => {
          if (data.data[0]) {
            this.$refs.auto.display = data.data[0].CODIGONOME
            this.$refs.auto.selectedDisplay = data.data[0].CODIGONOME
            this.$refs.auto.value = data.data[0].ID
          } else {
            this.$refs.auto.display = null
            this.$refs.auto.selectedDisplay = null
            this.$refs.auto.value = null
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    atualizaClasse () {
      if (this.classe === '0') {

      }
    }
  },
  watch: {
    // escuta o idInicial para pesquisar o cliente se o cadastro tiver cliente_id por exemplo
    'idInicial': function () {
      this.atualizaComplete()
    }
  },
  created () {
    this.atualizaComplete()
  }
}
</script>
<style>
.modal-dialog {
  top: 50px
}
.botao{
  /*
  border-radius: 0;
  border: 2px solid #20a8d8;
  */
  border-radius: 0;
  border: 2px solid #20a8d8;
}
.b-table .my-left-border {
  border-left: 1px solid #a4b7c1;
}
.b-table .my-left-right {
  border-right: 1px solid #a4b7c1;
}
.b-table .my-left-bottom {
  border-bottom: 1px solid #a4b7c1;
}
</style>



// WEBPACK FOOTER //
// src/views/pesquisa/OrdemAbateFechadaPesquisa.vue